module.exports = __webpack_public_path__ + "media/img/pwpush_logo-ed375cecc1214b6e3537b806f9c61b17.png";